<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>历史充值记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display:flex;align-items: center">
      <el-input v-model="phone" size="mini" style="width: 250px" placeholder="请输入会员手机号进行搜索"></el-input>
      <el-button size="mini"  style="margin-left: 5px;" @click="queryOldRecharge">查询</el-button>
    </div>
    <span>此处查询的是2022年10月1日之前的充值记录</span>
    <el-table height="510px" :data="rechargeList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        prop="rechargeTime"
        label="充值日期"
        align="center">
      </el-table-column>
      <el-table-column
        prop="money"
        label="充值金额"
        align="center">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="姓名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="充值门店"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      rechargeList:[],
      phone:''
    }
  },
  methods:{
    queryOldRecharge(){
      const {data:res} = this.$http.get(`old/recharge/list/${this.phone}`);
      if (res.code !== 200){
        this.rechargeList = res.data;
      }
    },
    refundTypeFormatter(row){
      // let value = "";
      // for (let i = 0; i < this.refundTypeText.length; i++){
      //   let item = this.refundTypeText[i];
      //   if (row.refundType === item.refundType) {
      //     value = item.name;
      //     break;
      //   }
      // }
      // return value;
    }
  }
}
</script>

<style lang="less" scoped>

.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__body{
  padding: 10px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/OldRecharge.vue